export function buildIVROptionsArray(start: number, end: number, allowSymbols = false): string[] {
    return Array.from({ length: end - start + 1 })
        .map((_, i) => Number(i + start).toString())
        .concat(allowSymbols ? ['#', '*'] : [])
}
